import Header from "../components/Header";
import React from "react";
import Container from '@mui/material/Container';

const Links = (props) => (
    <>
        <Header title="Links and Resources" sections={props.sections}/>
        <Container>
            <div>
                <p>Email: <a href='mailto:josh.axtell@gmail.com'>Josh.Axtell@gmail.com</a><br/>
                    LinkedIn: <a
                        href='https://www.linkedin.com/in/joshaxtell/'>https://www.linkedin.com/in/joshaxtell/</a>
                    <br/>
                    Contact Form: <a href='/contact'>Contact Joshua</a></p>
            </div>
            <h3>Recent projects and examples of my work for public websites:</h3>
            <div>
                <p>You'll notice that most of these sites have a similar layout, with a clean and minimalistic design.
                    Other site designs are available, and the styles on these sites can be updated at the customer's
                    request.</p>
                <p><a href="https://spacemarines5.com/">Space Marines 5</a>: A Site dedicated to teaching players how to
                    play the Laserforce tournament format game.</p>
                <p><a href="https://emblazonedindustries.com/">Emblazoned Industries</a>: A 2A Site with custom
                    integration for recurring membership payments and a custom solution for allowing customers to
                    reserve a spot and pay a deposit for upcoming training classes.</p>
                <p><a href="https://axtelladventures.com/">Axtell Adventures</a>: A Site with custom
                    integration for booking boat charters and connecting to a google calendar.</p>
                <p><a href={"https://fingerlakeswineconcierge.com/"}>Finger Lakes Wine Concierge</a>: A Site designed to
                    help the process of creating a customized wine tour.</p>
            </div>
            <h3>Other projects</h3>
            <div>
                <p>These projects are not publicly available, but here is a brief description of what they do.</p>
                <h4>Contacts web application</h4>
                <p>Allows a business or non-profit organization to track its members and allows members to send messages
                    to other members without having to give out their contact information or install another messaging
                    app.</p>
                <h4><a href={"https://bearatacs.axtell.technology/login"}>Bear aTACS</a></h4>
                <p>Built to streamline the process of doing the calculations needed for TACS grievances for the
                    APWU.</p>
                <h4>Laser Tag AI Assistant</h4>
                <p>AI trained on laser tag data.  An interactive tool to help teach players the rules and strategy of various laser tag games.</p>
            </div>
        </Container>
    </>
);

export default Links;